export class JackpotInfoModalData {
    small_jackpot_modal_array: number[];
    big_jackpot_modal_array: number[];
}
